module.exports = __webpack_public_path__ + "static/media/note-pencil.7b6c8093.svg";